import {
  LOTTERY_BUY_TICKETS_REQUEST,
  LOTTERY_BUY_TICKETS_SUCCESS,
  LOTTERY_BUY_TICKETS_FAILURE,
  LOTTERY_BUY_TICKETS_RESET
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOTTERY_BUY_TICKETS_REQUEST:
      return { ...state, isLoading: true, error: null };

    case LOTTERY_BUY_TICKETS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };

    case LOTTERY_BUY_TICKETS_RESET:
      return initialState;

    case LOTTERY_BUY_TICKETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};
